module.exports = __webpack_public_path__ + "img/item6.acc5eec4.png";